module.exports = __webpack_public_path__ + "img/logo1.6ec3538d.svg";